var map = {
	"./angemessene_therapie.png": 69343,
	"./angemessene_therapie_bubble.png": 4245,
	"./behinderung.png": 27974,
	"./behinderung_bubble.png": 76077,
	"./bildung.png": 24836,
	"./bildung_bubble.png": 49377,
	"./foerderleistung.png": 61858,
	"./foerderleistung_bubble.png": 1707,
	"./freizeit.png": 31160,
	"./freizeit_bubble.png": 66038,
	"./gesundheit.png": 43476,
	"./gesundheit_bubble.png": 11682,
	"./gesundheit_psychisch.png": 3327,
	"./gesundheit_psychisch_bubble.png": 13061,
	"./kindeswohl.png": 47503,
	"./kindeswohl_bubble.png": 90103,
	"./lebensstandard.png": 5710,
	"./lebensstandard_bubble.png": 10859,
	"./spitalbesuch.png": 52874,
	"./spitalbesuch_bubble.png": 93203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28615;